import React, { Component } from "react";
import PropTypes from "prop-types";

import { drawOnCanvas, renderSVG } from "./EdgeCoordinateV3";
import GenericChartComponent from "../GenericChartComponent";
import { getMouseCanvas } from "../GenericComponent";
import { functor, strokeDashTypes } from "../utils";

class PriceCoordinate extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
    this.drawOnCanvas = this.drawOnCanvas.bind(this);
  }
  drawOnCanvas(ctx, moreProps) {
    const props = helper(this.props, moreProps);
    drawOnCanvas(ctx, props);
  }
  renderSVG(moreProps) {
    const props = helper(this.props, moreProps);
    return renderSVG(props);
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        canvasDraw={this.drawOnCanvas}
        canvasToDraw={getMouseCanvas}
        drawOn={["pan", "drag", "mousemove", "resize"]}
      />
    );
  }
}

PriceCoordinate.propTypes = {
  displayFormat: PropTypes.func.isRequired,
  yAxisPad: PropTypes.number,
  rectWidth: PropTypes.number,
  rectHeight: PropTypes.number,
  orient: PropTypes.oneOf(["bottom", "top", "left", "right"]),
  at: PropTypes.oneOf(["bottom", "top", "left", "right"]),
  price: PropTypes.number,
  dx: PropTypes.number,
  arrowWidth: PropTypes.number,
  opacity: PropTypes.number,
  lineOpacity: PropTypes.number,
  lineStroke: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  strokeDasharray: PropTypes.oneOf(strokeDashTypes),
  stroke: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWidth: PropTypes.number,
  textFill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  alwaysShow: PropTypes.bool,
};

PriceCoordinate.defaultProps = {
  yAxisPad: 0,
  rectWidth: 50,
  rectHeight: 20,
  orient: "left",
  at: "left",
  price: 0,
  dx: 0,
  arrowWidth: 0,
  fill: "#BAB8b8",
  opacity: 1,
  lineOpacity: 0.2,
  lineStroke: "#000000",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 13,
  fontWeight: "normal",
  textFill: "#FFFFFF",
  strokeOpacity: 1,
  strokeWidth: 1,
  strokeDasharray: "Solid",
  alwaysShow: false,
};

function helper(props, moreProps) {
  const { width } = moreProps;
  const {
    chartConfig: { yScale, height },
  } = moreProps;
  const [lowerYValue, upperYValue] = yScale.domain();

  const { price, stroke, strokeDasharray, strokeOpacity, strokeWidth } = props;
  const { orient, at, rectWidth, rectHeight, displayFormat, dx } = props;
  const {
    fill,
    opacity,
    fontFamily,
    fontSize,
    fontWeight,
    textFill,
    arrowWidth,
    lineOpacity,
    lineStroke,
  } = props;

  const x1 = 0,
    x2 = width;
  const edgeAt = at === "right" ? width : 0;

  const type = "horizontal";

  const rawY = yScale(price);
  const isInRange = price <= upperYValue && price >= lowerYValue;

  // Issue #96: the last-close price pill opts in (alwaysShow) so it stays
  // visible clamped to the chart edge when the price goes out of view.
  // Every other consumer (indicator labels, interactive lines, order
  // lines, …) hides off-range labels — restoring the pre-#96 behavior so
  // they don't pile up on the panel seams (issue #300).
  const chartHeight = height || yScale.range()[0];
  const labelMargin = rectHeight / 2;
  const y = props.alwaysShow
    ? Math.max(labelMargin, Math.min(chartHeight - labelMargin, rawY))
    : rawY;
  const show = props.alwaysShow ? true : isInRange;

  const coordinate = displayFormat(price);
  const hideLine = !isInRange;

  const coordinateProps = {
    coordinate,
    show,
    type,
    orient,
    edgeAt,
    hideLine,
    lineOpacity,
    lineStroke,
    lineStrokeDasharray: strokeDasharray,
    stroke,
    strokeOpacity,
    strokeWidth,
    fill: functor(fill)(price),
    textFill: functor(textFill)(price),
    opacity,
    fontFamily,
    fontSize,
    fontWeight,
    rectWidth,
    rectHeight,
    arrowWidth,
    dx,
    x1,
    x2,
    y1: y,
    y2: y,
  };

  if (typeof window !== "undefined" && window.__capturePriceCoordinates__) {
    (window.__priceCoordinatesLog__ ||= []).push({
      price,
      coordinate,
      alwaysShow: props.alwaysShow === true,
      isInRange,
      show,
      y,
      chartHeight,
    });
  }

  return coordinateProps;
}

export default PriceCoordinate;

// Exposto para teste de regressão (#96/#300): decisão pura de show/clamp por alwaysShow.
export { helper as priceCoordinateHelper };
